// UZ-8606 recipe print view (layout/print.liquid): QR code, photo toggle and print button.
// qrcode-generator.js is loaded before this file (both deferred).
(() => {
  const qrTarget = document.querySelector('[data-recipe-qr]');
  if (qrTarget && typeof window.qrcode === 'function') {
    const code = window.qrcode(0, 'M');
    code.addData(qrTarget.dataset.recipeQr);
    code.make();
    qrTarget.innerHTML = code.createSvgTag({ cellSize: 4, margin: 0, scalable: true });
  }

  const photoToggle = document.querySelector('[data-print-photo]');
  if (photoToggle) {
    photoToggle.addEventListener('change', () => {
      document.body.classList.toggle('no-photo', !photoToggle.checked);
    });
  }

  document.querySelectorAll('[data-print]').forEach((button) => {
    button.addEventListener('click', () => window.print());
  });
})();
